import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import logComponent from '../../common/logComponent';

export default function YouTubeIcon({ link, style, className }) {
  if (logComponent('YouTubeIcon')) { console.debug('YouTubeIcon rendered'); }

  return  (
    <a href={link} className={className} title="You Tube" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon style={style} icon={faYoutube} />
    </a>
  )
}